import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { ConfirmationService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { CountryModel } from '../shared/models/country-model';

@Component({
  selector: 'app-tovpil-catalogs-countries',
  templateUrl: './tovpil-catalogs-countries.component.html',
  styleUrls: ['./tovpil-catalogs-countries.component.scss'],
  providers: [MessageService,ConfirmationService]
})
export class TovpilCatalogsCountriesComponent implements OnInit {

  listCountries: CountryModel[];
  country: CountryModel;
  countryDialog: boolean;
  submitted: boolean;

  constructor(
    private messageService: MessageService, 
    private confirmationService: ConfirmationService, 
    private apiService:ApiService
  ) { }

  ngOnInit(): void {
    this.apiService.getCountries().then(
      countr => {
          this.listCountries = countr;
      });
  }

  openNew() {
    this.country = {};
    this.submitted = false;
    this.countryDialog = true;
  }

  editCountry(coun: CountryModel) {
    this.country = {...coun};
    this.countryDialog = true;
  }

}
